import React, { ReactNode } from "react";
import { Card, CardHeader, CardTitle, CardBody, BoxProps } from "@govlaunch/web";
import { FormattedMessage } from "react-intl";

interface IStorySummaryProps {
  children: ReactNode;
}

export default function StorySummary({ children, ...props }: IStorySummaryProps & BoxProps) {
  return (
    <Card {...props}>
      <CardHeader justifyContent="flex-start" px={8}>
        <CardTitle color="black" as="h2">
          <FormattedMessage defaultMessage="Summary" id="RrCui3" />
        </CardTitle>
      </CardHeader>
      <CardBody>{children}</CardBody>
    </Card>
  );
}
